import React, {useState} from "react";
import { NavLink, useNavigate  } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../style/SideBar.css"
import {useAuth} from '../../contexts/AuthContext'
import { Modal, Button } from 'react-bootstrap';
import latte2 from "../assets/img/latte2.png";

export default function MerchantSideBar() {
  const {logout } = useAuth()
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

 function handleShowLogoutModal() {
  console.log('Show log out modal')
  setShowModal(true)
  }


  async function handleLogout() {
    try {
      await logout()
      navigate("/")
    } catch {
      alert("Failed to log out. Please try again")
      console.log("Failed to log out")
    }
  }
  return (
    <div className="d-flex flex-column justify-content-between p-3 vh-100">
      <div>
        <NavLink exact to="/dashboard" id='merchant-title' className="d-flex align-items-center text-decoration-none d-none d-sm-inline border-0" activeClassName="activeLink">
          <span id='merchant-title' className="ms-1 fs-4">Merchant</span>
        </NavLink>
        <hr className="d-none d-sm-block"></hr>
        <ul className="nav nav-pills flex-column">
          <li className="nav-item">
            <NavLink exact to="/dashboard" className="nav-link fs-5 my-1" activeClassName="activeLink">
              <i className="bi bi-house-fill"></i>
              <span className="ms-3 d-none d-sm-inline item d-none d-sm-inline">Dashboard</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/rating" className="nav-link fs-5 my-1" activeClassName="activeLink">
              <i className="bi bi-star-fill"></i>
              <span className="ms-3 d-none d-sm-inline item d-none d-sm-inline">Rating</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/profile" className="nav-link fs-5 my-1" activeClassName="activeLink">
              <i className="bi bi-person-fill"></i>
              <span className="ms-3 d-none d-sm-inline item d-none d-sm-inline">Profile</span>
            </NavLink>
          </li>
          <hr className="d-none d-sm-block"></hr>
          <li className="nav-item">
            <div onClick={handleShowLogoutModal} id="logoutBtn" className="nav-link fs-5 my-1" activeClassName="activeLink"> 
              <i className="bi bi-box-arrow-in-right"></i>
              <span  className="ms-3 d-none d-sm-inline item d-none d-sm-inline">Logout</span>
            </div>
          </li>
        </ul>
        
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Logout Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to log out?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button className="custom-button" onClick={handleLogout}>
            Logout
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
